import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const MemberContext = createContext(null);

export function MemberProvider({ children }) {
  const [member, setMember] = useState(undefined);
  const [loginOpen, setLoginOpen] = useState(false);
  const [paywall, setPaywall] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/members/me");
      setMember(data);
      return data;
    } catch {
      setMember(null);
      return null;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const logout = async () => {
    try { await api.post("/members/logout"); } catch { /* noop */ }
    setMember(null);
  };

  return (
    <MemberContext.Provider value={{ member, refresh, logout, loginOpen, setLoginOpen, paywall, setPaywall }}>
      {children}
    </MemberContext.Provider>
  );
}

export const useMember = () => useContext(MemberContext);
